import { Inject, Component } from "@angular/core";
import { OktaAuth } from "@okta/okta-auth-js";
import { OKTA_AUTH } from "@okta/okta-angular";
import { Observable, from, of } from "rxjs";
import { delay, switchMap } from "rxjs/operators";
import { ConfigService } from "@core/data/config.service";
import { LogoutService } from "@core/services/logout.service";

@Component({
    selector: "app-header",
    templateUrl: "./header.component.html",
    styleUrls: ["./header.component.scss"],
    standalone: false,
})
export class HeaderComponent {
    public loginLink: string;
    public navbarOpen = false;
    public $authenticated: Observable<boolean>;

    constructor(
        private conf: ConfigService,
        private logoutService: LogoutService,
        @Inject(OKTA_AUTH) private oktaAuthService: OktaAuth,
    ) {
        this.conf.populate().subscribe(() => {
            const base = this.conf.getMemberPortalUrlConfig();
            this.loginLink = `${base}/login`;
            this.$authenticated = of(false).pipe(
                delay(1500),
                switchMap(() => from(this.oktaAuthService.isAuthenticated())),
            );
        });
    }

    toggleNavbar() {
        this.navbarOpen = !this.navbarOpen;
    }

    logout() {
        this.logoutService.logout();
    }
}
